(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["euro-faq-premium"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.eef').forEach(function(root){
 var input=root.querySelector('#eef-search-input');
 var status=root.querySelector('.eef-results');
 if(!input)return;
 var all=Array.from(root.querySelectorAll('[data-faq-item]'));
 var sections=Array.from(root.querySelectorAll('[data-faq-group]'));
 input.addEventListener('input',function(){
  var term=(input.value||'').trim().toLocaleLowerCase();
  var shown=0;
  all.forEach(function(item){
   var text=item.textContent.toLocaleLowerCase();
   var match=!term||text.includes(term);
   item.hidden=!match;
   if(match)shown++;
  });
  sections.forEach(function(sec){sec.hidden=!Array.from(sec.querySelectorAll('[data-faq-item]')).some(function(x){return !x.hidden;});});
  if(status)status.hidden=shown>0||!term;
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
